export default __webpack_public_path__ + "static/media/twitter-white.05c2ea31.svg";